/**
 * Main navigation structure (labels and targets only — no UI logic).
 */

export const BRAND = {
  title: 'Van Gelder',
  shortTitle: 'SATE',
  homePath: '/',
};

export const HOME_LINK = {
  label: 'Home',
  path: '/',
};

export const PROJECTEN_LINK = {
  label: 'Projecten',
  path: '/projects',
};

export const CONTACT_LINK = {
  label: 'Contact',
  path: '/contact',
};

export const WERKINSTRUCTIES_LINK = {
  label: 'Handleiding',
  path: '/werkinstructies',
};

export const ADMIN_LINK = {
  label: 'Admin',
  path: '/admin/projects',
};

export const KPI_LINK = {
  label: 'Gebruik',
  path: '/admin/kpi',
};

export const LOGIN_LINK = {
  label: 'Inloggen',
  path: '/login',
};
